import { GroundShadow, LoaderSvg, SPARKLE_PATH, type VehicleLoaderProps } from "../loader-svg-parts";
import { VehicleOutline } from "../vehicle-outline";

const SPARKLES = [
  { x: 2, y: 20, scale: 1, delay: 0 },
  { x: 42, y: 14, scale: 0.8, delay: 0.6 },
  { x: 63, y: 30, scale: 1.1, delay: 1.2 },
  { x: 22, y: 13, scale: 0.6, delay: 1.8 },
];

const BUBBLES = [
  { x: 14, y: 24, r: 1.2, delay: 0.2 },
  { x: 30, y: 19, r: 0.9, delay: 0.9 },
  { x: 46, y: 28, r: 1.4, delay: 1.5 },
];

export function VehicleLoaderSparkle({ className }: VehicleLoaderProps) {
  return (
    <LoaderSvg viewBox="-4 6 72 52" modifiers="vehicle-loader-sparkling" className={className}>
      <GroundShadow />
      {BUBBLES.map(({ x, y, r, delay }) => (
        <circle
          key={`${x}-${y}`}
          cx={x}
          cy={y}
          r={r}
          strokeWidth={0.6}
          className="vehicle-loader-bubble stroke-primary/50 fill-primary/10"
          style={{ animationDelay: `${delay}s` }}
        />
      ))}
      <VehicleOutline />
      {SPARKLES.map(({ x, y, scale, delay }) => (
        <g key={`${x}-${y}`} transform={`translate(${x} ${y}) scale(${scale})`}>
          <path
            d={SPARKLE_PATH}
            className="vehicle-loader-sparkle fill-primary"
            style={{ animationDelay: `${delay}s` }}
          />
        </g>
      ))}
    </LoaderSvg>
  );
}
